

<div *ngIf="hotel" class="row">
    <div class="col-md-10 col-12">
        <h5 class="cusromGrey hotel_name">
            {{hotel.HotelName}}
        </h5>
        <ng-template *ngIf="hotel.StarRating === '' then noStar; else stars">
        </ng-template>
        <ng-template #noStar>
            <span class="star_rtng">
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
                <i class="fas fa-star"></i>
            </span>
        </ng-template>
        <ng-template #stars>
            <span class="star_rtng">
                <i class="fas fa-star star_rtng_clr" *ngFor="let s of hotel.StarRating | map: getStarArray"></i>
                <i class="fas fa-star" *ngFor="let s of hotel.StarRating | map: getStarArrayRemaining"></i>
            </span>
        </ng-template>

        <p class="cusromGrey hotel_location">
            {{hotel.HotelAddress}}
        </p>

       
        
    </div>

    <!-- <div class="col-md-2 col-12 pl-0 float-right">
        <span class="c_fmil2"><strong>Very Good</strong><br><small>380 reviews</small><span class="rating_box">4.0</span></span>
    </div> -->

</div>
